import {
    DataRecordValue,
    DataRecord,
    getColumnLabel,
    CategoricalColorNamespace,
} from '@superset-ui/core';
import { EChartsCoreOption, BarSeriesOption } from 'echarts';
import { OptionDataValue } from 'echarts/types/src/util/types';
import { defaultGrid, defaultTooltip } from '../../../defaults';
import {
    DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
    EchartsBarChartProps,
    EchartsBarFormData,
    BarChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';
import { CONSTANTS, getMetricSeriesData, getSeriesKeys, MetricSeriesData } from '../utils';

// basic  
  
export default function transformProps(
    chartProps: EchartsBarChartProps,
): BarChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metrics,
      combineMetrics,
      colorScheme,
      sliceId,
      showLegend,
    }: EchartsBarFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };

    const colorFn = CategoricalColorNamespace.getScale(colorScheme as string);

    // const drillDownColumns = Array.isArray(drillDownGroupby) ? drillDownGroupby :
    //   drillDownGroupby ? [drillDownGroupby] : [];
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel) : [getColumnLabel(groupby)];

    const keys = data.map(datum =>
      extractGroupbyLabel({ datum, groupby: groupbyLabels, coltypeMapping: {} }),
    );
    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;

    const multiMetricData: MetricSeriesData = getMetricSeriesData(metrics || [], data, combineMetrics);

    const series: BarSeriesOption[] = Object.values(multiMetricData).map(metricData => {
      return {
        name: metricData.name,
        coordinateSystem: 'cartesian2d',
        type: 'bar',
        color: colorFn(metricData.name, sliceId),
        // @ts-ignore
        data: combineMetrics ? ([...metricData.data, metricData.total] as OptionDataValue[])
          : (metricData.data as OptionDataValue[])
      };
    });
  
    const echartOptions: EChartsCoreOption = {
      grid: {
        ...defaultGrid,
        bottom: '10%'
      },
      legend: {
        show: showLegend,
        bottom: '2%'
      },
      tooltip: {
        ...defaultTooltip,
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
      },
      series,
      xAxis: [
        {
          type: 'category',
          data: combineMetrics ? getSeriesKeys(keys, CONSTANTS.combinedMetricLabel) : keys,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            hideOverlap: true
          }
        }
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            hideOverlap: true,
            show: true,
            width: 80,
            overflow: 'truncate',
          }
        }
      ]
    };
      
    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby,

      // enableDrillDown,
      // drillDownGroupby: drillDownColumns
    };
}
  